// map keys is used to map a key to a value, to rename that key
// example, if your return is "prod_down" and you want to rename it to "production downtime", for a chart or legend item or color
// you would add the following to the mapKeys object { prod_down: 'production downtime' }
// this well be used when processing the api call.  the new values should match up with the keys in the colors object and icons as well
export const mapKeys: Record<string, string> = {
  alarm_id: 'ID',
  alarm_description: 'alarm description',
  count: 'alarm occurances',
  alarm_category: 'category',
  alarm_type: 'alarm type',
  alarm_duration: 'duration',
  start_datetime: 'start date'
};
